import { SalesOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1220. 受注案件登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  name: string;
  description: string;
  user_id: number;
  business_partner_id: number;
  agency_id?: number;
  person_in_charge?: string;
  billing_target_id: number;
  product_id: number;
  spot_amount?: number;
  spot_billing_date?: string;
  monthly_amount?: number;
  monthly_billing_start_date?: string;
  monthly_billing_end_date?: string;
  contract_start_date?: string;
  contract_end_date?: string;
  delivery_date?: string;
  prev_sales_order_id?: number;
};

const createSalesOrder = (props: Props): Promise<SalesOrder> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders`, props);
};

export const useCreateSalesOrder = () => {
  return useMutation({
    mutationFn: createSalesOrder,
  });
};
